export const createCareerMutation = `
   mutation createcareer(
        $workspaceid: Int!, $mediaitemid: Int!, $name: String!, $courseIds: [Int]){
            CreateCareer(inputCreateCareer: {
                workspaceId: $workspaceid,
                mediaItemId: $mediaitemid,
                name: $name,
                courseIds: $courseIds
            }){
                career  {
                    id
                    name
                    slug
                    active
                    position
                    workspaceId
                    dateCreated
                    relatedMedia{
                    mediaitemid
                }
            }
        }
    }
`;
